import React from "react";
import { AuthorizationProvider } from "./auth/AuthorizationContext";
import { VoicePreferencesProvider } from "./auth/VoicePreferencesContext";
import AppRouter from "./router/AppRouter";
import "./App.scss";

function App() {
  // AuthorizationProvider must be inside AuthProvider / MockAuthProvider
  // (both live in index.js) so useAuth() is available to it.
  return (
    <AuthorizationProvider>
      <VoicePreferencesProvider>
        <AppRouter />
      </VoicePreferencesProvider>
    </AuthorizationProvider>
  );
}

export default App;
